import { createFileRoute } from '@tanstack/react-router';

// The Viewer start URL stays a valid canonical entry point; the layout route
// renders the presentation and treats no Slide segment as the first Slide.
export const Route = createFileRoute('/p/$shareId/')({ component: () => null });
